var render, staticRenderFns
import script from "./WAuthProviders.vue?vue&type=script&lang=js&"
export * from "./WAuthProviders.vue?vue&type=script&lang=js&"
import style0 from "./WAuthProviders.vue?vue&type=style&index=0&id=616db7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616db7ce",
  null
  
)

export default component.exports